import React from "react";
import { FiShield, FiVolume2, FiArrowRight } from "react-icons/fi";
import { BsDisc } from "react-icons/bs";
import "./ImmortalCards.css";

const ImmortalCards = () => {
  const cards = [
    {
      icon: <FiShield size={30}/>,
      title: "Enhanced Durability",
      description:
        "Heavier records resist warping and wear, preserving sound quality over time.",
    },
    {
      icon: <FiVolume2 size={30}/>,
      title: "Superior Sound",
      description:
        "Preferred by audiophiles for their ability to deliver deeper, more dynamic audio.",
    },
    {
      icon: <BsDisc size={30}/>,
      title: "Premium Weight",
      description:
        "Vintage records typically weigh 120–150 grams; 180-gram vinyl offers a luxurious upgrade.",
    },
  ];

  return (
    <section className="rt-immortal">
      {/* Animated background */}
      <div className="rt-immortal-bg">
        <div className="rt-immortal-bg-gradient"></div>
        <div className="rt-immortal-bg-pattern"></div>
      </div>

      <div className="rt-immortal-container">
        {/* Header with badge */}
        <div className="rt-immortal-header">
          <h2 className="rt-immortal-title">
            Why <span className="rt-immortal-title-highlight">180g Vinyl?</span>
          </h2>
        </div>

        {/* Cards grid */}
        <div className="rt-immortal-grid">
          {cards.map((card, index) => (
            <article 
              key={index} 
              className="rt-immortal-card"
            >
              {/* Card inner elements */}
              <div className="rt-immortal-card-inner">
                <div className="rt-immortal-card-bg">
                  <div className="rt-immortal-card-bg-pattern"></div>
                </div>
                
                <div className="rt-immortal-card-content">
                  {/* Icon with gradient background */}
                  <div className="rt-immortal-icon-wrapper">
                    <div className="rt-immortal-icon" aria-hidden="true">
                      {card.icon}
                    </div>
                  </div>

                  {/* Text content */}
                  <h3 className="rt-immortal-card-title">{card.title}</h3>
                  <p className="rt-immortal-card-description">{card.description}</p>
                </div>

                {/* Animated corner accents */}
                <div className="rt-immortal-card-corner rt-immortal-card-corner-tl"></div>
                <div className="rt-immortal-card-corner rt-immortal-card-corner-br"></div>
              </div>
            </article>
          ))}
        </div>
        <div className="mt-5 text-center">
          Celebrate the revival of musical heritage with vinyl that’s built to last <strong style={{color:'#9a3300',marginLeft:'3px'}}> and made to be heard.</strong></div>
      </div>
    </section>
  );
};

export default ImmortalCards;